module.exports = __webpack_public_path__ + "static/img/91489918d79ef6b585acc0308df392cf542c3bfe.3c476995.png";